import React from "react";

const StockSettings = React.lazy(() => import('src/pages/stock_settings/StockSettings'));

const routes = [
    { path: '/dashboard/stock-settings', name: 'Stock Settings', element: StockSettings },
];

export default routes;
